import React from 'react' // eslint-disable-line
import trix from 'trix' // eslint-disable-line

// eslint-disable-next-line no-console,no-undef
if (!trix) console.error('trix is required')

import '../pages/live_chat/index'

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    if (event.target.matches('a.download-href')) {
      event.target.setAttribute('download', true);
    }

    if (event.target.matches('a.target-blank')) {
      event.target.setAttribute('target', '_blank');
      event.target.setAttribute('rel', 'noopener');
    }
  });

  document.addEventListener('trix-initialize', function(event) {
    const editorElement = event.target;

    document.body.addEventListener('click', function(e) {
      if (e.target.matches('#trix-attach-button')) {
        editorElement.focus();

        pickFiles(function(files) {
          Array.from(files).forEach(file => editorElement.editor.insertFile(file));
        });

        e.preventDefault();
      }
    });
  });

  function pickFiles(callback) {
    let fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.style.display = 'none';
    document.body.appendChild(fileInput);

    function uninstall() {
      if (fileInput) {
        fileInput.remove();
        fileInput = null;
      }
    }

    fileInput.addEventListener('change', function() {
      callback(this.files);
      uninstall();
    });

    fileInput.click();

    requestAnimationFrame(() => {
      document.addEventListener('click', uninstall, { once: true });
    });
  }
});

import ahoy from "ahoy.js"
ahoy.configure({
  cookies: false,
  visitsUrl: window.speakeasySettings.apiBase + "/ahoy/ahoy/visits",
  eventsUrl: window.speakeasySettings.apiBase + "/ahoy/ahoy/events"
});
ahoy.trackClicks("a, button, input[type=submit]");
ahoy.trackSubmits("form");
